import { useEffect } from 'react';
import * as React from 'react';

import { connect } from 'react-redux';

import { accountActions } from '../../actions/account.actions';
import { useIntercom } from '../../services/intercom/useIntercom';
import Loading from '../Loading';

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => {
  const { account } = state;
  return {
    account,
  };
};

type MappedDispatch = {
  logout: () => Promise<void>;
};

const mapDispatchToProps = (dispatch: ThunkDispatch): MappedDispatch => ({
  logout: async () => {
    try {
      await dispatch(accountActions.logout());
    } catch (error) {
      console.error('Error dispatching accountActions.logout', error);
    }
  },
});

type Props = MappedState & MappedDispatch;

const Logout: React.FC<Props> = ({ account, logout }) => {
  const { shutdown } = useIntercom();

  useEffect(() => {
    if (account.authorized) {
      (async () => {
        shutdown();
        await logout();
      })();
    }
  }, [account.authorized, logout, shutdown]);

  return <Loading fullscreen />;
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
